import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class BillingConfigurationBillingPresetActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Property/BillingPreset/BillingPresetBrowser")
	}

	render() {
		return (
			<Activity 
				name="BillingConfigurationBillingPreset"
				RenderedComponent={this.RenderedComponent}
				context="BillingConfigurationBillingPreset"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(BillingConfigurationBillingPresetActivity)
